import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function AddKeywordsUpload({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Add Keywords - Upload CSV'}  email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

